import State from "@/helpers/pattern/state";
import { Tipo } from "@/models/operativos/tipo";
import { modelIsModified } from "@/helpers/vue-mc";
import tipoAPI from "@/services/operativos/tipo";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";
import { scrollToForm } from "@/helpers/form-scroll-to";

/**
 * State Pattern for tipo form
 */
export default class TipoStates extends State {
  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.tipo = new Tipo();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.tipo) || $data.view.action.submit.busy || !modelIsModified($data.tipo);
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models and validators
          this.resetModel();
          this.resetValidators();

          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;
        }
        , async submit({ $data }, { descripcion, canales, localizacion, contacto, adicional, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await tipoAPI.save({
              clave: null
              , descripcion
              , canales: canales.join()
              , localizacion
              , contacto
              , adicional
              , status
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.tipoTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, { clave, descripcion, canales, localizacion, contacto, adicional, status }) {
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.update;

          $data.tipo = new Tipo({
            clave
            , descripcion
            , canales: canales.split(",")
            , localizacion
            , contacto
            , adicional
            , status
          });

          this.resetValidators();
          scrollToForm($data);
        }
        , async submit({ $data, $setState }, { clave, descripcion, canales, localizacion, contacto, adicional, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy = true;

            const response = await tipoAPI.update({
              clave
              , descripcion
              , canales: canales.join()
              , localizacion
              , contacto
              , adicional
              , status
            });

            $data.$refs.tipoTable.refreshData();
            $data.view.action.submit.busy = false;
            $setState("initial");
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/operativos/tipo/tipo-state.js